import React from 'react'
import { Input } from './Input'
import { toast } from 'react-toastify'
import SvgCopy from './icons/SvgCopy'
import SvgShare from './icons/SvgShare'

export interface ShareLinkProps {
	link: string
}


export const ShareLink: React.FunctionComponent<ShareLinkProps> = ({ link }) => {
	
	return (
		<div className='shareLink'>
			<div className='shareLink-icon'>
				<SvgShare/>
			</div>
			<Input
				value={link}
				onClick={() => {
					navigator.clipboard.writeText(link);
					toast.success('Odkaz zkopírován do schránky.')}}
				readOnly
				label={'Pro sdílení si kliknutím zkopírujte odkaz do schránky'}
			/>
		</div>
	)
}
